import { render, staticRenderFns } from "./EnumList.vue?vue&type=template&id=64a479b4&"
import script from "./EnumList.vue?vue&type=script&lang=ts&"
export * from "./EnumList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports